/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CreateAnnouncementsRouteImport } from './routes/create-announcements'
import { Route as AnnouncementsRouteImport } from './routes/announcements'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChatConversationIdRouteImport } from './routes/chat.$conversationId'

const CreateAnnouncementsRoute = CreateAnnouncementsRouteImport.update({
  id: '/create-announcements',
  path: '/create-announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatConversationIdRoute = ChatConversationIdRouteImport.update({
  id: '/chat/$conversationId',
  path: '/chat/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agents': typeof AgentsRoute
  '/announcements': typeof AnnouncementsRoute
  '/create-announcements': typeof CreateAnnouncementsRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agents': typeof AgentsRoute
  '/announcements': typeof AnnouncementsRoute
  '/create-announcements': typeof CreateAnnouncementsRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agents': typeof AgentsRoute
  '/announcements': typeof AnnouncementsRoute
  '/create-announcements': typeof CreateAnnouncementsRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agents'
    | '/announcements'
    | '/create-announcements'
    | '/chat/$conversationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/agents'
    | '/announcements'
    | '/create-announcements'
    | '/chat/$conversationId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agents'
    | '/announcements'
    | '/create-announcements'
    | '/chat/$conversationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AgentsRoute: typeof AgentsRoute
  AnnouncementsRoute: typeof AnnouncementsRoute
  CreateAnnouncementsRoute: typeof CreateAnnouncementsRoute
  ChatConversationIdRoute: typeof ChatConversationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/create-announcements': {
      id: '/create-announcements'
      path: '/create-announcements'
      fullPath: '/create-announcements'
      preLoaderRoute: typeof CreateAnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$conversationId': {
      id: '/chat/$conversationId'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId'
      preLoaderRoute: typeof ChatConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AgentsRoute: AgentsRoute,
  AnnouncementsRoute: AnnouncementsRoute,
  CreateAnnouncementsRoute: CreateAnnouncementsRoute,
  ChatConversationIdRoute: ChatConversationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
